import { ClientCargoTemplateFromApi } from "./index";
import * as t from "io-ts";
import { Stop, stopT } from "../cargo-and-template-shared";
import { apiStopToFormStop } from "../cargo-dialog/helpers";
import { CargoFormData } from "../cargo-dialog/types";
import { convertStopUnitsStringToDecimal } from "dora-shared";

type ApiStop = t.TypeOf<typeof stopT>;

export const apiCargoTemplateToFormData = (
  d: ClientCargoTemplateFromApi
): CargoFormData => {
  const { data } = d;
  return {
    ...data,
    // Client cargo templates don't carry CMR config.
    cmrConfigs: [],
    clientId: data.clientId || undefined,
    customerContactId: data.customerContactId || null,
    invoiceRef: data.invoiceRef || null,
    description: data.description || "",
    description2: data.description2 || "",
    qualities: data.qualities || [],
    requirements: data.requirements || [],
    products: data.products,
    clientContactEmail: data.clientContactEmail || "",
    clientContactPhone: data.clientContactPhone || "",
    clientContact: data.clientContact || "",
    driverCanAddDropoffs: data.driverCanAddDropoffs || false,
    minTemperature: data.minTemperature || "",
    maxTemperature: data.maxTemperature || "",
    containerNo: data.containerNo || "",
    pickupList: data.pickupList.map(apiStopToFormStop),
    dropoffList: data.dropoffList.map(apiStopToFormStop),
    stopUnits: data.stopUnits.map((su) => ({
      ...su,
      ...convertStopUnitsStringToDecimal(su),
    })),
    note: data.note || "",
  };
};

export const formDataStopToApiStop = (stop: Stop): ApiStop => {
  return {
    ...stop,
    loadmeters: stop.loadmeters.toString(),
  };
};
